import { useTranslation } from 'react-i18next';

export const faqKeys = [1, 2, 3, 4, 5];

function splitParagraphs(value: string): string[] {
  return value.split(/\n{2,}/);
}

export default function FAQSection() {
  const { t } = useTranslation();
  return (
    <section className="py-20 bg-primary-900 text-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-4xl font-serif mb-10">{t('howToBecomeButler.faq.title')}</h2>
        {faqKeys.map((i) => (
          <details key={i} className="border-b py-5">
            <summary>{t(`howToBecomeButler.faq.q${i}`)}</summary>
            {splitParagraphs(t(`howToBecomeButler.faq.a${i}`)).map((paragraph, index) => (
              <p key={index} className="mt-4">{paragraph}</p>
            ))}
          </details>
        ))}
      </div>
    </section>
  );
}
